import { css, Theme } from '@emotion/react'
import { Container } from '@mui/material'

import { GetAllNewsQuery } from 'generated/graphql.api'
import NewsList from '~/components/organisms/NewsList'

type Props = {
  data: GetAllNewsQuery
}

const NewsListTemplate: React.FC<Props> = ({ data }) => {
  return (
    <Container component='section' css={styles.container}>
      <div css={styles.title}>ニュースリリース</div>
      <div css={styles.subTitle}>News Release</div>
      <NewsList data={data} />
    </Container>
  )
}

const styles = {
  container: css`
    max-width: 1180px;
    margin: 0 auto;
    padding: 200px 0 100px;
    @media (max-width: 1200px) {
      width: 800px;
    }
    @media (max-width: 768px) {
      width: 85%;
      padding: 150px 0 100px;
    }
  `,
  title: (theme: Theme) => css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 4rem;
    color: ${theme.palette.primary.main};
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  `,
  subTitle: (theme: Theme) => css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.6rem;
    color: ${theme.palette.primary.main};
  `,
}

export default NewsListTemplate
